export default __webpack_public_path__ + "static/media/js-icon.a1a083fd.svg";